import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatDate } from "@/lib/utils/formatters";
import ShiftReportEntry from "@/modules/shiftReports/components/ShiftReportEntry";
import { ReadShiftReport } from "@/types/shiftReport";
import { Pencil, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

interface ShiftReportCollapsibleContentProps {
  data: ReadShiftReport;
  onClose(): void;
}

const ShiftReportCollapsibleContent = ({
  data,
  onClose,
}: ShiftReportCollapsibleContentProps) => {
  const { t } = useTranslation();

  return (
    <Card
      className="flex flex-col overflow-hidden h-full"
      data-testid="shift-report-collapsible-content"
    >
      <CardHeader className="border-b backdrop-blur sticky top-0 z-10 p-4 flex-none gap-2">
        <div className="flex items-start justify-between">
          <CardTitle className="text-md font-medium flex flex-col gap-1">
            <div className="mb-2">
              <Button variant="secondary" asChild>
                <Link to={`/shift-reports/${data.id}`}>
                  <Pencil className="h-4 w-4" />
                  {t("shiftReports.entry.edit")}
                </Link>
              </Button>
            </div>
            <span className="text-lg font-semibold text-gray-900 flex flex-row items-center gap-2">
              <span data-testid="shift-report-date">
                {formatDate(data.shift_date)}
              </span>
              <span className="mx-2 text-gray-400">·</span>
              <span data-testid="shift-report-name">{data.shift_name}</span>
            </span>
            <span className="text-sm font-normal text-slate-500 mt-0.5 leading-5">
              <span data-testid="shift-report-store-name">
                {data.store_name}
              </span>
            </span>
          </CardTitle>
          <Button
            onClick={onClose}
            variant="secondary"
            size="icon"
            className="shrink-0"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </CardHeader>
      <CardContent className="p-4 pb-0 mb-4 overflow-auto flex-1">
        <div className="space-y-1.5">
          {data?.department_entries.map((entry, index) => (
            <ShiftReportEntry key={index} entry={entry} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ShiftReportCollapsibleContent;
